import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { IAttendingPhysician, IAttendingPhysicianCreate } from './types';

const apiUrl = 'attending-physicians';

export const getByProgramId = (programId: number): IResponse<IAttendingPhysician[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-program-id/${programId}`,
  });

export const create = (
  programId: number,
  data: IAttendingPhysicianCreate,
): IResponse<IAttendingPhysician> =>
  axios({
    method: 'post',
    url: apiUrl,
    params: {
      programId,
    },
    data,
  });

export const update = (data: IAttendingPhysician): IResponse<IAttendingPhysician> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
